import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"none meet\" viewBox=\"0 0 25 25\" id=\"icon-check\"><g transform=\"translate(-830 -411)\"><circle data-name=\"椭圆 24\" cx=\"12.5\" cy=\"12.5\" r=\"12.5\" transform=\"translate(830 411)\" fill=\"#4388ff\" /><path data-name=\"联合 6\" d=\"M840.778 428.145a.292.292 0 0 1-.219-.105l-3.005-3.125a.748.748 0 0 1 0-1.028.679.679 0 0 1 .987 0l2.439 2.536 6.132-6.387a.679.679 0 0 1 .987 0 .749.749 0 0 1 0 1.028l-6.626 6.899a.682.682 0 0 1-.494.213.674.674 0 0 1-.201-.031z\" fill=\"#fff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol